
import makerjs from "makerjs";
function B46(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,R = Param[2].param,
    // T = Param[3].param,S1 = Param[4].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
       b = B * 1 * myZoom,       
       l = L * 1 * myZoom,       
       r = R * 1 * myZoom,       
       h = r,
       w = b,
       hd=r-l,
       x0 = 0, x1 = 0, x2 =hd ,x3 =b ,x4 =b, 
       y0 = 0, y1 =l,y2 =r, y3 =r,y4=0,glassH =l, glassW = w;
       if (b !== 0) {
        var TxtB ="B="+ B;
    }  if (l !== 0) {
     var TxtL = "L="+L;
   }    if (r !== 0) {
     var TxtR = "R="+R;
   }
   var drawAbnormalShapeB46 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "LeftArcLine": new makerjs.paths.Arc([x1, y1], [x2,y2], hd,false,true),
        "TopLine": new makerjs.paths.Line([x2,y2], [x3,y3]),
        "RightLine": new makerjs.paths.Line([x3,y3], [x4,y4]),
        "BottomLine": new makerjs.paths.Line([x4,y4],[0, 0]),
       }
   };
   var drawAbnormalShapeB46MarkB = {
       paths: {
        "bottomLine": new makerjs.paths.Line([0, -markShift], [b, -markShift]),        
        "RightShortUpline": new makerjs.paths.Line([0, 0], [0, -3*markShift]),
        "RightShortDnline": new makerjs.paths.Line([b, 0], [b, -3*markShift]),
       }  
   };
   var drawAbnormalShapeB46MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x1- markShift, y1]),
        "RightShortUpline": new makerjs.paths.Line([x0, y0], [x0- 2 * markShift, y0]),
        "RightShortDnline": new makerjs.paths.Line([x1, y1], [x1- 2 * markShift, y1]),
       }
   };
   var drawAbnormalShapeB46MarkR = {
       paths: {
        "RightLine": new makerjs.paths.Line([x4+ markShift, y4], [x3+ markShift, y3]),
        "RightShortUpline": new makerjs.paths.Line([x3, y3], [x3+ 4 * markShift, y3]),
        "RightShortDnline": new makerjs.paths.Line([x4, y4], [x4+ 4 * markShift, y4]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeB46MarkB, TxtB,  [0,-2*markShift], [b, -2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB46MarkL, TxtL,  [x0- 2*markShift, y0], [x1- 2*markShift, y1]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB46MarkR, TxtR,  [x4+ 2*markShift, y4], [x3+ 2*markShift, y3]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB46: drawAbnormalShapeB46,
      }
    };
  markers={
      models: {
        drawAbnormalShapeB46: drawAbnormalShapeB46,
        drawAbnormalShapeB46MarkB:drawAbnormalShapeB46MarkB,
        drawAbnormalShapeB46MarkL:drawAbnormalShapeB46MarkL,
        drawAbnormalShapeB46MarkR:drawAbnormalShapeB46MarkR,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B46;